import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import { HelpLink } from '../../../../../components/generic'
import { SUPPORT_LINK } from '../components/constants'
import ShiftPasswordItem from './ShiftPasswordItem'

const ShiftPasswordsList = ({ shifts, onDelete, testId }) => {
  const headings = ['Title', 'Start / End', 'Access Time', 'Actions']

  return (
    <div data-testid={testId}>
      <div
        style={styles.headingsContainer}
        data-testid={testId ? `${testId}-headings` : undefined}
      >
        {headings.map((heading, i) => (
          <div
            key={i}
            style={styles.heading}
            data-testid={testId ? `${testId}-heading-${i}` : undefined}
          >
            {heading}
          </div>
        ))}
      </div>
      <div style={styles.subDivider} />
      <ul
        style={styles.list}
        data-testid={testId ? `${testId}-items` : undefined}
      >
        {shifts?.map((shift, index) => (
          <div
            key={shift.id}
            className="lmc-list-item"
            data-testid={testId ? `${testId}-item-${index}` : undefined}
          >
            <ShiftPasswordItem
              shift={shift}
              onDelete={onDelete}
              testId={testId ? `${testId}-item-${index}` : undefined}
            />
            <div style={styles.subDivider} />
          </div>
        ))}
      </ul>
      <div
        style={{ paddingTop: 10 }}
        data-testid={testId ? `${testId}-help` : undefined}
      >
        <HelpLink supportLink={SUPPORT_LINK} style={styles.helpLink} />
      </div>
    </div>
  )
}

const styles = {
  heading: {
    width: '25%',
    minWidth: 70,
    fontWeight: 300,
    fontSize: 20,
    color: colors.darkgrey
  },
  headingsContainer: {
    width: '100%',
    minWidth: 290,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  helpLink: {},
  list: {
    listStyle: 'none',
    listStyleType: 'none',
    padding: 0
  },
  noShiftsMessage: {
    position: 'relative',
    top: 50
  },
  subDivider: {
    backgroundColor: colors.grey,
    height: 2,
    marginTop: 8
  }
}

ShiftPasswordsList.propTypes = {
  shifts: PropTypes.array,
  onDelete: PropTypes.func.isRequired
}

export default ShiftPasswordsList
